/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line


  




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();

function myFunction() {
  let dots = document.getElementById("dots"),
      moreText = document.getElementById("homemore"),
      btnText = document.getElementById("myBtn");

  dots.classList.toggle("hidden");
  moreText.classList.toggle("hidden");

  btnText.innerHTML = dots.classList.contains("hidden") ? "Read less" : "Read more";
}
